import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'productNotFoundDialog.title',
    defaultMessage: 'Product not found',
    description: 'Title of the product not found dialog',
  },
  message: {
    id: 'productNotFoundDialog.message',
    defaultMessage:
      "The product that you've scanned could not be found. Check if you have the correct product.",
    description: 'Message of the product not found dialog',
  },
  actions: {
    close: {
      id: 'actions.close',
      defaultMessage: 'Close',
      description: 'Label of the close action of the product not found dialog',
    },
  },
};

export default defineMessages(translations);
